<!-- TODO same: src/components/texts/TableEmptyText.vue -->
<template>
  <v-list-item
    :class="$style.noDataSelectVListItem"
    data-testid="noDataSelectVListItem"
  >
    <slot>No such data</slot>
  </v-list-item>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.noDataSelectVListItem {
  color: colors.$color-gray-600;
  padding: 15px;
  font-style: italic;
}
</style>
